import React, { useEffect, useState, useMemo } from "react";
import { Checkbox, Radio, Input, Form, InputNumber, Alert } from "antd";
import { connect } from "react-redux";
import { ADDFIELDS } from "../../../core-units/constants/actionTypes";
import agent from "../../../agent";
import "../ev-home-page.css";
import _ from "lodash";

const { TextArea } = Input;

const StepSellerDetails = (props) => {
  const [form] = Form.useForm();
  const [evService, setEvService] = useState({});
  const [evProduct, setEvProduct] = useState({});
  const [evCoupon, setEvCoupon] = useState({});
  const [evTotal, setEvTotal] = useState(0);
  const [evRego, setEvRego] = useState("Rego");
  const [evCheck1, setEvCheck1] = useState(false);
  const [evCheck2, setEvCheck2] = useState(false);
  const [evFieldStatus, setEvFieldStatus] = useState(false);
  const [evClient, setEvClientPhone] = useState("");
  const [allEvValues, setAllEvValues] = useState({
    name: "",
    phone: "",
    email: "",
    SellerName: "",
    SellerPhonenumber: "",
    CarLocation: "",
    CarModel: "",
    OdometerReading: "",
    CarIdNumber: "",
    price: "",
    notes: "",
    year: "",
  });
  /** Normalise rego value to expected labels */
  const normalizeRego = (val) => {
    if (!val && val !== "") return null;
    const s = (val || "").toString().trim().toLowerCase();
    if (s === "rego" || s === "reg" || s === "registration") return "Rego";
    if (s.includes("vin")) return "VIN";
    if (s.includes("chasis") || s.includes("chassis") || s.includes("chasis number") || s.includes("chassis number")) return "Chasis Number";
    return null;
  };


  /** Load initial data once */
  useEffect(() => {
    async function apiCall() {
      const storedService = localStorage.getItem("evService");
      const storedProduct = localStorage.getItem("evProduct");
      const storedValues = localStorage.getItem("allEvValues");
      const carAppNumber = localStorage.getItem("evRego");
      // Normalise stored rego or set default
      const normalised = normalizeRego(carAppNumber);
      const regoValue = normalised || "Rego";
      if (normalised === null && carAppNumber) {
        console.warn("[Seller Details] Unexpected evRego value in localStorage:", carAppNumber, "-> resetting to default 'Rego'");
      }
      // Persist normalized/default value on load so other consumers (payment/index)
      // that read localStorage get a consistent, valid label.
      localStorage.setItem("evRego", regoValue);
      props.regoValidation(regoValue);
      
      const parsedService = storedService ? JSON.parse(storedService) : {};
      const parsedProduct = storedProduct ? JSON.parse(storedProduct) : {};
      const parsedValues = storedValues ? JSON.parse(storedValues) : {};
      setEvService(parsedService);
      setEvProduct(parsedProduct);
      setEvCoupon(localStorage.getItem("evCouponData"));
      setEvTotal(localStorage.getItem("evTotal"));
      setAllEvValues(parsedValues);
      setEvRego(regoValue);
      setEvFieldStatus(JSON.parse(localStorage.getItem("evFieldStatus")) || false);
      setEvCheck1(JSON.parse(localStorage.getItem("evCheck1")) || false);
      setEvCheck2(JSON.parse(localStorage.getItem("evCheck2")) || false);

      // Load form values after data ready
      form.setFieldsValue(parsedValues);

      // Validate form on load
      const emailPattern = /^([A-Za-z0-9._%+-])+@([A-Za-z0-9.-])+\.[A-Za-z]{2,}$/;
      
      const initialChecks = {
        name: !!(parsedValues.name && parsedValues.name.trim() !== ""),
        email: !!(parsedValues.email && parsedValues.email.trim() !== ""),
        SellerName: !!(parsedValues.SellerName && parsedValues.SellerName.trim() !== ""),
        SellerPhonenumber: !!(parsedValues.SellerPhonenumber && parsedValues.SellerPhonenumber.toString().trim() !== ""),
        CarModel: !!(parsedValues.CarModel && parsedValues.CarModel.trim() !== ""),
        CarIdNumber: !!(parsedValues.CarIdNumber && parsedValues.CarIdNumber.toString().trim() !== ""),
        OdometerReading: !!(parsedValues.OdometerReading !== null && parsedValues.OdometerReading !== undefined && parsedValues.OdometerReading !== ""),
        emailValid: emailPattern.test(parsedValues.email || ""),
      };
      
      const isValid = Object.values(initialChecks).every(v => v === true);

      props.formvalidateHandler(isValid);
      setEvFieldStatus(isValid);
      localStorage.setItem("evFieldStatus", JSON.stringify(isValid));

      // Fetch additional fields from API
      props.fields({ "filter[service_id]": _.get(parsedService, "id") });
    }
    apiCall();
  }, []);

  /** Form value change handler */
  const onFormLayoutChange = (changedValues, allValues) => {
    // Always get ALL form values directly from the form instance, don't rely on allValues parameter
    const currentFormValues = form.getFieldsValue();
    const merged = { ...allEvValues, ...currentFormValues };
    setAllEvValues(merged);
    localStorage.setItem("allEvValues", JSON.stringify(merged));

    const emailPattern = /^([A-Za-z0-9._%+-])+@([A-Za-z0-9.-])+\.[A-Za-z]{2,}$/;
    
    // Check each condition separately for debugging
    const checks = {
      name_value: merged.name,
      name_valid: !!(merged.name && merged.name.trim() !== ""),
      email_value: merged.email,
      email_valid: !!(merged.email && merged.email.trim() !== ""),
      emailFormat_valid: emailPattern.test(merged.email || ""),
      SellerName_value: merged.SellerName,
      SellerName_valid: !!(merged.SellerName && merged.SellerName.trim() !== ""),
      SellerPhonenumber_value: merged.SellerPhonenumber,
      SellerPhonenumber_valid: !!(merged.SellerPhonenumber && merged.SellerPhonenumber.toString().trim() !== ""),
      CarModel_value: merged.CarModel,
      CarModel_valid: !!(merged.CarModel && merged.CarModel.trim() !== ""),
      CarIdNumber_value: merged.CarIdNumber,
      CarIdNumber_valid: !!(merged.CarIdNumber && merged.CarIdNumber.toString().trim() !== ""),
      OdometerReading_value: merged.OdometerReading,
      OdometerReading_valid: !!(merged.OdometerReading !== null && merged.OdometerReading !== undefined && merged.OdometerReading !== ""),
    };
    
    const isValid = checks.name_valid && checks.email_valid && checks.emailFormat_valid &&
                    checks.SellerName_valid && checks.SellerPhonenumber_valid && 
                    checks.CarModel_valid && checks.CarIdNumber_valid && checks.OdometerReading_valid;
    props.formvalidateHandler(isValid);
    setEvFieldStatus(isValid);
    localStorage.setItem("evFieldStatus", JSON.stringify(isValid));
  };

  /** Radio group change */
  const carNoChange = (e) => {
    const raw = e.target.value;
    const value = normalizeRego(raw) || "Rego";
    props.regoValidation(value);
    setEvRego(value);
    localStorage.setItem("evRego", value);
  };

  /** Terms checkboxes */
  const checkChange1 = (e) => {
    const value = e.target.checked;
    props.termsValidationHandler(value);
    setEvCheck1(value);
    localStorage.setItem("evCheck1", JSON.stringify(value));
  };

  const checkChange2 = (e) => {
    const value = e.target.checked;
    props.checkValidationHandler(value);
    setEvCheck2(value);
    localStorage.setItem("evCheck2", JSON.stringify(value));
  };

  /** Service & Price details */
  const serviceProductDetails = () => (
    <>
      <div className="EvPricingAddOnTitle">
        Your Details, Seller and Car Details
      </div>
      <div className="EvInspectionStepTitle">
        {_.get(evService, "name")} <b>$ {_.get(evService, "price")}</b>
        {_.map(evProduct, (val, key) => (
          <React.Fragment key={key}>
            + {_.get(val, "name")} <b>$ {_.get(val, "price")}</b>
          </React.Fragment>
        ))}
      </div>
      <div className="EvCouponCodeTotal">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-2">
            <div className="EvCouponCodeTotalSection">
              <span>Total</span>
              <span className="EvCouponCodeTotalAmount">$ {evTotal}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  /** Form info */
  const formInfo = () => (
    <Form
      form={form}
      layout="vertical"
      initialValues={allEvValues}
      onValuesChange={onFormLayoutChange}
      validateTrigger={["onBlur"]}
      className="row"
    >
      <Form.Item
        className="col-12 col-lg-8"
        label="Your Name"
        name="name"
        rules={[{ required: true, message: "Please input your username!" }]}
      >
        <Input />
      </Form.Item>

      {/* Email */}
      <Form.Item
        className="col-12 col-lg-8"
        label="Your E-mail Address"
        name="email"
        rules={[
          {
            required: true,
            type: "email",
            message: "Please input your email!",
          },
        ]}
      >
        <Input />
      </Form.Item>

      {/* Phone */}
      <Form.Item
        className="col-12 col-lg-8 phone__number--preImg"
        label="Your Phone Number"
        name="phone"
        rules={[{ required: true, message: "Please input your phone!" }]}
      >
        <Input
          prefix={"+61"}
          onChange={(e) => setEvClientPhone("+61" + e.target.value)}
        />
      </Form.Item>

      <Form.Item className="col-12">
        <hr />
      </Form.Item>

      {/* Seller Info */}
      <Form.Item
        className="col-12 col-lg-8"
        label="Seller Name"
        name="SellerName"
        rules={[{ required: true, message: "Please input your Seller Name!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        className="col-12 col-lg-8"
        label="Seller Phone Number"
        name="SellerPhonenumber"
        rules={[
          { required: true, message: "Please input your Seller Phone Number!" },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item className="col-12">
        <hr />
      </Form.Item>

      {/* Car Details */}
      <Form.Item
        className="col-12 col-lg-8"
        label="Car Make and Model"
        name="CarModel"
        rules={[{ required: true, message: "Please input your Car Model!" }]}
      >
        <Input placeholder="Hyundai i20" />
      </Form.Item>

      <Form.Item
        className="col-12 col-lg-8"
        label="Car Manufactured Year"
        name="year"
      >
        <Input placeholder="2022" />
      </Form.Item>

      <Form.Item
        className="col-12 col-lg-8"
        label="Car Odometer Reading"
        name="OdometerReading"
        rules={[
          { required: true, message: "Please enter Car Odometer Reading!" },
        ]}
      >
        <InputNumber placeholder="130,000" style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item className="col-12">
        <Radio.Group
          className="EvSellerDetailsRadioGroup"
          name="radiogroup"
          value={evRego}
          onChange={carNoChange}
        >
          <Radio value="Rego">Car Rego Number</Radio>
          <Radio value="VIN">Car VIN Number</Radio>
          <Radio value="Chasis Number">Car Chasis Number</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        className="col-12 col-lg-8"
        name="CarIdNumber"
        rules={[
          { required: true, message: "Please input your Car appropriate Number!" },
        ]}
      >
        <Input placeholder="E.g. 123" />
      </Form.Item>

      {/* Notes */}
      <Form.Item className="col-12 col-lg-8" label="Notes" name="notes">
        <TextArea rows={3} />
      </Form.Item>

      {/* Terms Checkboxes */}
      <Form.Item className="col-12 col-lg-8">
        <div className="EvAcceptTermsCheckBoxSet">
          <Checkbox onChange={checkChange1} checked={evCheck1} />
          <div className="AcceptTermsCheckBoxText">
            I agree to the&nbsp;
            <a
              className="footer-terms-conditions"
              href="https://www.safe-buy.com.au/read-the-terms-conditions-of-prepurchase-vehicle-services/"
              target="_blank"
            >
              Terms and Conditions
            </a>
          </div>
        </div>
        <div className="EvAcceptTermsCheckBoxSet">
          <Checkbox onChange={checkChange2} checked={evCheck2} />
          <div className="AcceptTermsCheckBoxText">
            I agree to{" "}
            <a
              href="https://safebuy.com.au/booking-refund-and-cancellation-policy/"
              target="_blank"
            >
              Service, Booking and Refund Policy
            </a>
          </div>
        </div>
      </Form.Item>
    </Form>
  );

  /** Render */
  const visibleAlert = useMemo(() => props.isAlert, [props.isAlert]);
  return (
    <div className="EvStepSellerDetailsStepsContainer">
      <div className="EvStepAppointmentInfo">
        {serviceProductDetails()}
        {visibleAlert && (
          <div className="row justify-content-center">
            <div className="col-12 col-lg-7">
              <Alert
                message="Error"
                description="Please fill all required fields"
                type="error"
                showIcon
              />
            </div>
          </div>
        )}
        <div className="EvStepsFormCardContainer">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-7">
              <div className="EvStepsFormCard">{formInfo()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/** Redux */
const mapStateToProps = (state) => ({
  addfield: state.booking.additionalfields,
});

const mapDispatchToProps = (dispatch) => ({
  fields: (params, callback) =>
    dispatch({
      type: ADDFIELDS,
      payload: agent.Bookings.addition_feilds(params),
      callback,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(StepSellerDetails);
